module.exports = __webpack_public_path__ + "static/media/Avatars_Male-22.1a35e6ca.png";